/**
 * What the storefront shows (D-363). Two things are switched off, and nothing was deleted: the code for them is all still
 * there and comes back when the build says so.
 *
 * - **Prices**: every stone shows "Ask for the price" — the price is given on enquiry — instead of an amount, a
 *   discount or a struck-through price; the price filter, the price sort and the price in the page's structured data
 *   go with them. `VITE_SHOW_PRICES=true` at build time shows them again.
 * - **Badges**: "New", "Featured", "Made when you order", "Only a few left" and the "In stock" line … on the photographs of the tiles and under the
 *   title of the product page are not shown — a tile is its picture, name and actions. `VITE_SHOW_BADGES=true` brings them back.
 * - **Save**: the heart on the cards and the "Save" button on the product page. `VITE_SHOW_SAVE=true` brings them back.
 *
 * Functions (not bare constants) so that a test can switch the old behaviour back on for the screens that still have
 * tests for it (`vi.mock('@/lib/catalog/storefront')` in `test/setup.ts`), and the Playwright stack builds with both on
 * to keep the price and Save screens covered (`scripts/e2e-web.ts`).
 */
export const pricesShown = (): boolean => import.meta.env.VITE_SHOW_PRICES === 'true';
export const saveShown = (): boolean => import.meta.env.VITE_SHOW_SAVE === 'true';
export const badgesShown = (): boolean => import.meta.env.VITE_SHOW_BADGES === 'true';
